// Regra da personalização: frase OU arte, pelo menos um dos dois.
//
// Antes o campo de texto era obrigatório sozinho, então quem só queria mandar
// a arte tinha de escrever alguma coisa para o formulário deixar passar.
//
// A validação usa setCustomValidity no campo de texto e é mantida em dia a
// cada digitação. Assim o reportValidity() que os dois botões de compra já
// chamam encontra o erro pronto, sem duplicar regra em dois lugares.
(() => {
  const AVISO = 'Escreva a frase da estampa ou envie a sua arte — pelo menos um dos dois.';

  const conferir = (grupo) => {
    const texto = grupo.querySelector('[data-perso-texto]');
    const arquivo = grupo.querySelector('[data-perso-arquivo]');
    if (!texto) return;

    // Sem campo de arquivo na página, a frase volta a ser o único caminho.
    const temTexto = texto.value.trim() !== '';
    const temArquivo = arquivo && arquivo.files && arquivo.files.length > 0;

    texto.setCustomValidity(temTexto || temArquivo ? '' : AVISO);
  };

  const conferirTodos = () => {
    document.querySelectorAll('[data-perso-grupo]').forEach(conferir);
  };

  document.addEventListener('input', (evento) => {
    const grupo = evento.target.closest('[data-perso-grupo]');
    if (grupo) conferir(grupo);
  });

  document.addEventListener('change', (evento) => {
    const grupo = evento.target.closest('[data-perso-grupo]');
    if (grupo) conferir(grupo);
  });

  document.addEventListener('DOMContentLoaded', conferirTodos);
  conferirTodos();
})();
